import MessageThreadHeaderList from './MessageThreadHeaderList';

export default MessageThreadHeaderList;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadHeaderList/index.js